export class CarouselHero extends HTMLElement {
    constructor() {
        super();

        this.selectors = {
            mainCarousel: "[js-hero-carousel]",
            thumbsCarousel: "[js-hero-thumbs-carousel]",
        };
    }

    connectedCallback() {
        this.mainCarousel = this.querySelector(this.selectors.mainCarousel);
        this.thumbsCarousel = this.querySelector(this.selectors.thumbsCarousel);

        if (this.mainCarousel && this.thumbsCarousel) {
            window.requestAnimationFrame(this._connectCarousels);
        }
    }

    _connectCarousels = () => {
        if (!this.mainCarousel?.swiper || !this.thumbsCarousel?.swiper) {
            return;
        }

        this.mainCarousel.swiper.controller.control =
            this.thumbsCarousel.swiper;
        this.thumbsCarousel.swiper.controller.control =
            this.mainCarousel.swiper;
    };
}
